import { PATHS } from "../../../packs/travel_book/avia_v3/utils/variables/api"
import baseApi from "../baseApi"

const buildBundleUrl = (endpoint) =>
  `${PATHS.ADMIN.BASE}${PATHS.ADMIN.STATES}/${endpoint ? endpoint : ""}`

export const statesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStates: builder.query({
      query: () => ({
        url: buildBundleUrl(""),
        method: "GET",
      }),
    }),
  }),
})

export const { useGetStatesQuery, useLazyGetStatesQuery } = statesService
